module.exports = __webpack_public_path__ + "img/Sprengen.2c764905.svg";